import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface IConfirmDialogProps {
  open: boolean;
  proceedButtonText?: string;
  cancelButtonText?: string;
  onPressProceed: () => void;
  onPressCancel: () => void;
  isPending?: boolean;
  text: string;
  title: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    minWidth: 400,
  },
}));

export const ConfirmDialog = (props: IConfirmDialogProps) => {
  const classes = useStyles();
  const { open, proceedButtonText = 'Yes', cancelButtonText = 'Cancel', onPressProceed, onPressCancel, isPending, text, title } = props;

  return (
    <Dialog
      open={open}
      onClose={onPressCancel}
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onPressCancel} disabled={isPending} style={{ fontSize: 15, fontFamily: 'Noto Sans', fontWeight: 700 }}>
          {cancelButtonText}
        </Button>
        <Button
          onClick={onPressProceed}
          color="primary"
          autoFocus
          disabled={isPending}
          style={{ fontSize: 15, fontFamily: 'Noto Sans', fontWeight: 700 }}
        >
          {proceedButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
